"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Error to be thrown if storage API is not supported by the device.
 * @public
 */
exports.ErrNoStorageSupport = new Error('Current device does not support storage API');
/**
 * Error to be thrown if requested key was not found in the storage.
 * @public
 */
exports.ErrKeyNotFound = new Error('Requested key was not present in storage');
//# sourceMappingURL=types.js.map